import { OpenReplayProvider } from './context.client'

export const useOpenReplay = () => {}

export const OpenReplay = {
  Provider: OpenReplayProvider,
}
